<template>
  <div class="wrapper">
    <public-title accountnumber="账号" loginmethod="登录方式" :methodarrs="methodarr"  @gotoinquire="eventinquire" :isbtn="false"
      icon="el-icon-plus">
    </public-title>
    <div class="content">
      <el-table :data="tabledata" style="width: 100%" >
        <el-table-column prop="phone" label="账号" align="center">
        </el-table-column>
        <el-table-column prop="nickname" label="昵称" width="180" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="登录时间" align="center">
        </el-table-column>
        <el-table-column prop="ip" label="登录IP" align="center">
        </el-table-column>
        <el-table-column prop="readTime" label="浏览时长" align="center">
        </el-table-column>
        <el-table-column prop="method" label="登录方式" align="center">
        </el-table-column>
        <el-table-column label="操作" width="250" align="center">
          <template slot-scope="scope">
            <!-- <el-popconfirm v-if="scope.row.status==1" icon="el-icon-info" v-model="DelVisible" confirmButtonText='确定' cancelButtonText='取消'
              @onConfirm="handleDelete(scope.$index, scope.row)" iconColor="red" style="margin-left: 10px;"
              title="您确定要封锁IP吗？"> -->
              <el-button v-if="scope.row.status==1" slot="reference" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">封锁IP</el-button>
            <!-- </el-popconfirm> -->
            <!-- <el-popconfirm v-else icon="el-icon-info" v-model="DelVisible" confirmButtonText='确定' cancelButtonText='取消'
              @onConfirm="dearchive(scope.$index, scope.row)" iconColor="red" style="margin-left: 10px;"
              title="您确定要解封IP吗？"> -->
              <el-button v-else slot="reference" size="mini" type="primary" @click="dearchive(scope.$index, scope.row)">解封IP</el-button>
            <!-- </el-popconfirm> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[15, 30, 40, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper"
        :total="totals">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import publicTitle from '../../../components/publicTitle'
  export default {
    components: { publicTitle },
    props: {},
    data() {
      return {
        tabledata: [],
        currentPage: 1,
        pageSize: 15,
        pageIndex: 1,
        totals: 0,
        DelVisible: false,
        methodarr:[],
        form:{}
      };
    },
    computed: {
    },
    mounted() {
      this.updata()
      this.loginmethod()
    },
    methods: {
      loginmethod(){
        this.$http({
          url: this.$api.detailslist + `?type=method`,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            console.log(res.data.data)
            this.methodarr = res.data.data
          }else{
            this.$toast("error", res.data.msg);
          }
        })
      },
      updata(pageIndex = 1, pageSize = 15, Vaccountnumber = '', Vloginmethod = '') {
        this.$http({
          url: this.$api.loginLoglist + `?pageIndex=${pageIndex}&pageSize=${pageSize}&userName=${Vaccountnumber}&method=${Vloginmethod}`,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            console.log(res.data)
            this.tabledata = res.data.data.records
            this.pageSize = res.data.data.size
            this.currentPage = res.data.data.current
            this.totals = res.data.data.total
          }else{
            this.$toast("error", res.data.msg);
          }
        });
      },
      eventinquire(form) {
        this.form = form
        this.updata(1, this.pageSize, this.form.Vaccountnumber,this.form.Vloginmethod)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.updata(this.pageIndex, this.pageSize, this.form.Vaccountnumber,this.form.Vloginmethod)
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.updata(this.pageIndex, this.pageSize, this.form.Vaccountnumber,this.form.Vloginmethod)
      },
      //封IP
      handleDelete(index, item) {
        let userId = JSON.parse(sessionStorage.getItem("userinfo")).id
        var data = {
          userId,
          id:item.id
        }
        this.$http({
          url: this.$api.loginLogprohibitiont,
          method: "POST",
          data
        }).then(res => {
          if (res.data.code == 200) {
            this.$toast("success", res.data.msg);
            this.updata(this.pageIndex, this.pageSize , this.form.Vaccountnumber,this.form.Vloginmethod)
          }else{
            this.$toast("error", res.data.msg);
          }
          this.DelVisible = false
        });
      },
      //解IP
      dearchive(index, item) {
        let userId = JSON.parse(sessionStorage.getItem("userinfo")).id
        var data = {
          userId,
          id:item.id
        }
        this.$http({
          url: this.$api.loginLogdeblocking,
          method: "POST",
          data
        }).then(res => {
          if (res.data.code == 200) {
            this.$toast("success", res.data.msg);
            this.updata(this.pageIndex, this.pageSize,  this.form.Vaccountnumber,this.form.Vloginmethod)
          }else{
            this.$toast("error", res.data.msg);
          }
          this.DelVisible = false
        });
      },
    },
    created() { },
    beforeDestroy() { }
  };
</script>

<style lang="scss" scoped>
  .role-select {
    width: 290px !important;
  }

  .content {
    background: #fff;
    width: 100%;
    height: 100%;
    // padding-bottom: 7%!important;
  }

  /deep/.el-pagination {
    text-align: center;
    // padding: 10px 0;
    padding-bottom:10px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .wrapper{
    height: 100%;

  }
/deep/.el-table{
  // overflow-x: scroll;
}
/deep/.el-table::before{
  background-color: none;
  opacity:0;
}
/deep/.el-table th>.cell{
  color: #000;
}
/deep/.el-table__body-wrapper{
  height:63vh;
  overflow-y: auto;
}
</style>